import { render, staticRenderFns } from "./JobsSection.vue?vue&type=template&id=5f952cfe&scoped=true"
import script from "./JobsSection.vue?vue&type=script&lang=js"
export * from "./JobsSection.vue?vue&type=script&lang=js"
import style0 from "./JobsSection.vue?vue&type=style&index=0&id=5f952cfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f952cfe",
  null
  
)

export default component.exports